import Axios from "../BaseAxios";
import {API_ADMIN_URL} from "../../constants/urls";
import Keys from "../../constants/keys";
import store from "../../store";

const AdminApiHelper = {
  getClientInternalTeamList: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_ADMIN_URL.clientInternalTeamList,
      requestParams,
      {},
      successHandler,
      failureHandler,
      true
    );
  },
  getAllResources(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      store.state.allResources.loading = false;

      if (store.state.allResources.pagination.page == 1)
        store.state.allResources.items = [];

      if (store.state.allResources.items.length < 1) {
        store.state.allResources.items = res.data.data;
      } else {
        store.state.allResources.items = store.state.allResources.items.concat(
          res.data.data
        );
      }
      store.state.allResources.itemsTotal = res.data.recordsTotal;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.allResources.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] = store.state.allResources.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.allResources.search;

    if (
      store.state.allResources.pagination.page >
      store.state.allResources.items.length / 16
    ) {
      store.state.allResources.loading = true;
      Axios.request_POST(
        API_ADMIN_URL.resourceList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle
      );
    }
  },

  getResourcesToManage(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      store.state.managementResources.loading = false;

      if (store.state.managementResources.pagination.page == 1)
        store.state.managementResources.items = [];

      if (store.state.managementResources.items.length < 1) {
        store.state.managementResources.items = res.data.data;
      } else {
        store.state.managementResources.items = store.state.managementResources.items.concat(
          res.data.data
        );
      }
      store.state.managementResources.itemsTotal = res.data.recordsTotal;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.managementResources.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] =
      store.state.managementResources.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.managementResources.search;

    if (
      store.state.managementResources.pagination.page >
      store.state.managementResources.items.length / 16
    ) {
      store.state.managementResources.loading = true;
      Axios.request_POST(
        API_ADMIN_URL.resourceManagementList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle
      );
    }
  },

  addClientMasterStep: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_ADMIN_URL.stepAdd,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },
};

export default AdminApiHelper;
